/**
 * アクティビティ見直し進捗APIサービス
 *
 * タイムラインをどこまで見直したかの水位線を扱う。
 * フルアクセス権限を持つユーザーのみ使用可能
 */

import { apiClient } from '@/api/client'

export type ActivityReviewProgress = {
  /** この日まで見直し済み（YYYY-MM-DD）。未設定なら null */
  reviewed_through_date: string | null
  /** 見直し済みの日から今日までの日数 */
  unreviewed_days: number
  updated_at: string | null
}

/**
 * 見直し進捗を取得
 */
export const getActivityReviewProgress = async (): Promise<ActivityReviewProgress> => {
  const res = await apiClient.get('/activity/review-progress')
  return res.data
}

/**
 * 見直し済みの日付を更新
 * @param date YYYY-MM-DD形式
 */
export const updateActivityReviewProgress = async (date: string): Promise<ActivityReviewProgress> => {
  const res = await apiClient.put('/activity/review-progress', { date })
  return res.data
}
